import { Geometry } from "wkx"

export type CoordinateValue = {
  longitude: number
  latitude: number
}

type PossibleShapes =
  | GeoJSON.Point
  | GeoJSON.Polygon
  | GeoJSON.LineString
  | GeoJSON.MultiPolygon

export const getGeometryFromWkb = <T extends PossibleShapes>(
  wkbString: string,
) => {
  // Convert the hex string to a buffer
  const buffer = Buffer.from(wkbString, "hex")

  // Parse the WKB
  const geometry = Geometry.parse(buffer).toGeoJSON() as T
  return geometry
}

export const getGeometryFromWkt = <T extends PossibleShapes>(
  wktString: string,
) => {
  // Convert the hex string to a buffer

  // Parse the WKB
  const geometry = Geometry.parse(wktString).toGeoJSON() as T
  return geometry
}

export const parsePostGISPoint = (wkbString: string) => {
  const geometry = getGeometryFromWkb<GeoJSON.Point>(wkbString)
  try {
    return {
      latitude: geometry["coordinates"][1],
      longitude: geometry["coordinates"][0],
    } as CoordinateValue
  } catch (error) {
    throw new Error("Invalid WKB point string")
  }
}

export const getGeoJSONFromWkb = <Shape extends PossibleShapes>(
  wkbString: string,
): GeoJSON.Feature<Shape> => ({
  type: "Feature",
  geometry: getGeometryFromWkb<Shape>(wkbString),
  properties: {},
})

export const getWktFromGeoJSON = (geoJSON: PossibleShapes) =>
  Geometry.parseGeoJSON(geoJSON).toWkt()

export const getWkbFromGeometry = (geometry: PossibleShapes) =>
  Geometry.parseGeoJSON(geometry).toWkb().toString("hex")
